import React from "react";
import "./Approved.css";
import { CheckCircleFilled } from '@ant-design/icons';

export const Approved = props => {
    return (
        <div className="approvedRoot">
            <div className="approvedWrapper">
                <CheckCircleFilled className="approvedIcon" />
                <p>{props.message}</p>
                <p>Name : <b>{props.displayName}</b></p>
                {
                    props.dateStr &&
                    <p>Assessment Date: <b>{props.dateStr}</b></p>
                }
            </div>
        </div>
    );
}
